/*
 * @Description: 商户管理
 * @Author: gao shuai
 * @Date: 2020-04-22 19:21:29
 * @LastEditTime: 2020-08-19 15:37:34
 * @LastEditors: gao shuai
 */

import api from '../assets/js/apiRequestHandler';
import mgr from '../assets/js/securityapi';
export default {
  /* ------------------------1.平台商户----------------------- */
  // 平台商户列表
  async platlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取费率列表
  async rankdrow(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetRankList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 审核通过
  async statepass(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ExamineMerchant',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更新商户状态
  async stateupdatea(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UpdateMerchantState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 删除商户
  async merchantdel(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/DeleteMerchant',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取商户的信息
  async merchantinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantDetail',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取银行信息列表
  async bankinfo(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantBank',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取商户专属产品列表
  async getUserProducts(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetUserProducts',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 开户银行下拉
  async bankdrow(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetBanks',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更新商户资金信息
  async bankupdate(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UpdateMerchantBank',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 更新商户专属产品信息
  async userProductUpdate(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/AddUserProducts',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 重置商户密码
  async passwordset(params) {
    let header = await mgr();
    return api({
      url: '/api/UserManage/ResetTenantPassword',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 冻结和解冻请求
  async frozenbank(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UpdateMerchantBankState',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更新商户
  async updatemerchant(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UpdateMerchant',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 更新商户
  async gomerchant(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GoMerchant',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 商户费率的列表
  async rankList1111111(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/GetTenantRankPageListAsync',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 列表中切换费率组
  async ChangeMerchantRank(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ChangeMerchantRankAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 解绑微信
  async unbindWeixin(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UnbindMerchantWeixinAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 解锁锁定的ip
  async useripLock(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/RemoveUserIpLock',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 一键下线功能
  async oneUnload(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/AKeyOffline',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 取消商户代理
  async setAgent(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ChangeToAgentAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 设置为商户代理
  async cancelAgent(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ChangeAgentToTenantAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 可切换费率查询
  async rankcheck(params) {
    let header = await mgr();
    return api({
      url: '/api/ManageRank/GetTenantDefaultRankPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 重置二级密码
  async resetPassword(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ResetMerchantSecondaryPasswordAysnc',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  /* ------------------------2.代理商户----------------------- */
  // 平台商户列表
  async agentlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetAgentMerchantPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 注册商户列表
  async registerlist(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetAuditMerchantPageList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  async GetMerchantOtherList(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantOtherList',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批量删除注册商户
  async merchartsDel(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/BatchDeleteMerchant',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 批量审核商户
  async merchartsPass(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/BatchExamineMerchant',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 代付
  async daifu(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ChangePaid',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 微信验证
  async signWechat(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/ChangeWxValid',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 更改账户类型
  async paidAccountType(params) {
    let header = await mgr();
    return api({
      url: '/api/Paid/ChangeUserType',
      method: 'get',
      params: params,
      headers: {
        Authorization: 'Bearer ' + header
      }
    });
  },
  // 添加或更新指定产品通道
  async setProductChannel(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/SaveMerchantGalleryProducts',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取指定商户的产品通道列表
  async getMerchantGalleryProducts(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantGalleryProducts',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 获取指定bankid的通道状态
  async getChannelStatus(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerGalleries',
      method: 'post',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },
  // 提交资料
  async uploadGallery(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/UploadGalleryAsync',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 获取商户产品通道设置（包含开关 enabled 和已设置的通道列表）
  async getMerchantGalleryProductSetting(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantGalleryProductSetting',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 保存商户产品通道设置（同时保存开关和通道映射）
  async saveMerchantGalleryProductSetting(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/SaveMerchantGalleryProductSetting',
      method: 'post',
      data: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 获取商户 ThirdBankUser 列表（新版三方虚拟户）
  async getMerchantThirdBankUsers(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetMerchantThirdBankUsers',
      method: 'get',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 一次性获取所有商户 ThirdBankUser 数据（性能优化）
  async getAllMerchantThirdBankUsers() {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/GetAllMerchantThirdBankUsers',
      method: 'get',
      headers: { Authorization: 'Bearer ' + header }
    });
  },

  // 删除商户 ThirdBankUser 记录（按主键 Id 删除；使用 POST，避免网关/CDN 拦截 DELETE）
  async deleteMerchantThirdBankUser(params) {
    let header = await mgr();
    return api({
      url: '/api/ApplicationUser/DeleteMerchantThirdBankUser',
      method: 'post',
      params: params,
      headers: { Authorization: 'Bearer ' + header }
    });
  }

};
